<template>
  <v-dialog
    v-model="open"
    class="dialog"
    width="1000">
    <v-layout column class="wrapper"
    :class="{
      'py-8 pr-8 pl-18': $vuetify.breakpoint.smAndUp,
      'pa-8': $vuetify.breakpoint.xsOnly
    }">
      <v-layout justify-end>
        <v-icon @click="close()" color="accent" :size="40">close</v-icon>
      </v-layout>
      <div class="package-name break-word" :class="{ 'pb-5': $vuetify.breakpoint.smAndUp }">
        {{ name }}
      </div>
      <div class="price">
        {{ priceStr }}
      </div>
      <v-divider :class="{ 'my-5': $vuetify.breakpoint.smAndUp }" />
      <div class="description" v-if="description">
        {{ description }}
      </div>
      <v-layout align-center wrap justify-end>
        <v-flex xs12 sm7 md8 lg9>
          <v-layout :justify-end="$vuetify.breakpoint.mdAndUp" :justify-center="$vuetify.breakpoint.smAndDown">
            <v-layout column class="fit-content" :class="{ 'mr-8': $vuetify.breakpoint.smAndUp }">
              <span class="quantity-text">
                {{ $t('fields.quantity') }}
              </span>
              <v-layout justify-space-between>
                <v-btn icon outlined fab color="accent" @click="quantity--" :disabled="!priceStr || !quantity">
                  <v-icon size="40" color="accent">remove</v-icon>
                </v-btn>
                <span class="quantity">{{ quantity }}</span>
                <tooltip-button
                  @click="quantity++"
                  :disabled="addDisabled"
                  :disabledTooltip="!addDisabled"
                  :tooltipText="!product
                    ? ''
                    : getPackageTokenBalance(product.id)
                      ? $t('catalog.maximum_token_amount_reached_with_current', { max: product.maxTokenAmountOnAccount, curr: getPackageTokenBalance(product.id) })
                      : $t('catalog.maximum_token_amount_reached', { max: product.maxTokenAmountOnAccount })"
                  color="accent"
                  :iconSize=40
                  icon="add"
                  fab
                />
              </v-layout>
            </v-layout>
            <v-divider v-if="$vuetify.breakpoint.smAndUp" vertical class="mt-9" :class="{ 'mr-9': $vuetify.breakpoint.smAndUp }" />
          </v-layout>
        </v-flex>
        <v-flex xs12 sm5 md4 lg3 align-end>
          <main-button
            :text="$vuetify.breakpoint.smAndUp ? $t('catalog.add_package') : $t('actions.add')"
            @click="addProduct()"
            :disabled="isBookingDisabled || (!getProductInCart({ product }) && !quantity)"
            medium
            class="mt-9" />
        </v-flex>
      </v-layout>
    </v-layout>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import moneyFormatMixins from '@/mixins/MoneyFormat'

export default {
  props: {
    triggerOpen: Date,
    exchangeCurrency: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      open: false,
      quantityByPrice: []
    }
  },
  computed: {
    ...mapGetters({
      product: 'cart/product',
      getQuantity: 'cart/getQuantity',
      accountCurrencies: 'guests/accountCurrencies',
      accountPricingGroupId: 'guests/accountPricingGroupId',
      getApplicablePrice: 'guests/getApplicablePrice',
      getPackageTokenBalance: 'guests/getPackageTokenBalance',
      maximumTokenAmountReached: 'guests/maximumTokenAmountReached',
      isBookingDisabled: 'bookings/isBookingDisabled',
      getProductInCart: 'cart/getProductInCart'
    }),
    name () {
      return this.product ? this.product.name : null
    },
    description () {
      return this.product ? this.product.description : null
    },
    quantity: {
      get () {
        return this.product ? this.getQuantity({ product: this.product, isTemp: true }) || 0 : 0
      },
      set (q) {
        this.$store.commit('cart/setQuantity', q)
      }
    },
    priceStr () {
      const applicablePrice = this.product ? this.getApplicablePrice(this.product.pricingGroupWithPrices) : null
      return typeof applicablePrice === 'number'
        ? `${this.quantity ? this.quantity + 'x ' : ''} ${this.formatAmount(applicablePrice / this.exchangeCurrency.exchangeRate)} ${this.exchangeCurrency.currency.name}`
        : null
    },
    addDisabled () {
      return !this.priceStr || this.maximumTokenAmountReached({ product: this.product, quantity: this.quantity })
    }
  },
  methods: {
    accept () {
      this.$emit('accept')
      this.open = false
    },
    close () {
      this.$emit('close')
      this.open = false
    },
    addProduct () {
      this.$store.commit('cart/updateCartProduct')
      this.open = false
    }
  },
  watch: {
    triggerOpen () {
      this.open = true
    },
    open (open) {
      this.$store.commit('state/setInModal', open)
      if (!open) {
        this.$store.commit('cart/resetProduct')
      } else if (!this.quantity && !this.addDisabled) {
        this.quantity = 1
      }
    }
  },
  components: {
    MainButton: () => import('@/components/app-components/MainButton.vue'),
    TooltipButton: () => import('@/components/app-components/TooltipButton.vue')
  },
  mixins: [moneyFormatMixins],
  beforeDestroy () {
    this.$store.commit('state/setInModal', false)
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-dialog {
    border-radius: 10px;
  }
}
.wrapper {
  background-color: white;
}
.package-name {
  color: #392F2C;
  font-weight: 800;
  @media (max-width: 600px) {
    font-size: 25px;
  }
  @media (min-width: 601px) {
    font-size: 50px;
  }
}
.price {
  color: var(--v-primary-base);
  font-size: 30px;
  font-weight: 800;
}
.description {
  font-size: 20px;
  font-weight: 200;
  line-height: 35px;
  margin-bottom: 40px;
}
.quantity-text {
  font-size: 20px;
  text-align: center;
  margin-bottom: 8px;
}
.quantity {
  font-size: 40px;
  color: var(--v-primary-base);
  font-weight: 800;
  margin-right: 32px;
  margin-left: 32px;
}
</style>
